import { AppModal } from 'shared/UI/UIKit/Modal';
import { RoomForm } from 'features/building/components/Form';
import type { RoomModalProps } from '../../types';
import { useCreateService } from '../model';
import { RoomModalFooter } from '../../Footer';

interface CreateRoomModalProps extends RoomModalProps {
  buildingId: number;
  onItemCreate: () => void;
}

export const CreateRoomModal = ({
  buildingId,
  hide,
  visible,
  onItemCreate,
}: CreateRoomModalProps) => {
  const {
    state: { form, loading },
    methods: { hideModal, onSubmit },
  } = useCreateService({ buildingId, hide, onItemCreate });

  const footer = <RoomModalFooter onSubmit={onSubmit} hideModal={hideModal} title="Сохранить" />;
  const content = <RoomForm form={form} />;

  return (
    <AppModal
      visible={visible}
      onCancel={hideModal}
      content={content}
      destroyOnClose
      footer={footer}
      loading={loading}
      title="Создать аудиторию"
      maskClosable={false}
    />
  );
};
